import { z } from 'zod';

export const TeslaInitiateConnectionResultSchema = z.object({ url: z.string() });
